import { Analytics } from './Analytics'

// TODO(CS-2173): Remove caching on module level.
let instance: Analytics | null = null

/**
 *
 */
export function fwnAnalyticsGetter() {
  return instance ?? (instance = new Analytics())
}
